(function () {
  var pollInterval = null;

  function unlockSubmit() {
    var styleBlock = document.getElementById('captcha-gate');
    if (styleBlock) styleBlock.remove();
    document.querySelectorAll('button.shogun-form-box-submit').forEach(function (btn) {
      btn.classList.add('captcha-verified');
    });
  }

  function lockSubmit() {
    document.querySelectorAll('button.shogun-form-box-submit').forEach(function (btn) {
      btn.classList.remove('captcha-verified');
    });
  }

  function checkCaptchaState() {
    if (typeof grecaptcha === 'undefined' || typeof grecaptcha.getResponse !== 'function') {
      return;
    }
    try {
      var response = grecaptcha.getResponse();
      if (response && response.length > 0) {
        unlockSubmit();
      } else {
        lockSubmit();
      }
    } catch (e) {
      // grecaptcha not fully initialized yet
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    pollInterval = setInterval(checkCaptchaState, 300);
  });

  // Fallback: also check on click of reCAPTCHA container
  document.addEventListener('click', function (e) {
    if (e.target.closest('.g-recaptcha')) {
      setTimeout(checkCaptchaState, 500);
    }
  });

})();